import { BackendInterface, DataResponse } from "../..";
import {
  NewsletterSubscription,
  NewsletterSubscriptionSource,
} from "@imagine/shared-base";

/**
 * Subscribes to the newsletter. Works both for a logged-in user (the backend picks up
 * the session automatically) and anonymously, e.g. a "subscribe" link/button clicked
 * from a newsletter email or during sign-up before login — pass the signed `token` from
 * that link in those cases (see NewsletterTokens on the backend for how it's issued).
 */
const subscribe = async (
  backend: BackendInterface,
  source: NewsletterSubscriptionSource,
  token?: string,
) => {
  const result = await backend.post("newsletter-subscription/subscribe", {
    source,
    token,
  });
  const response: DataResponse<NewsletterSubscription> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  } else {
    backend.captureException("Failed to subscribe to newsletter", {
      Result: JSON.stringify(result),
    });
  }
  return response;
};

/**
 * Unsubscribes from the newsletter. Works both for a logged-in user (the backend picks
 * up the session automatically) and anonymously via the signed `token` from an
 * unsubscribe link clicked in a newsletter email.
 */
const unsubscribe = async (backend: BackendInterface, token?: string) => {
  const result = await backend.post("newsletter-subscription/unsubscribe", {
    token,
  });
  const response: DataResponse<NewsletterSubscription> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  } else {
    backend.captureException("Failed to unsubscribe from newsletter", {
      Result: JSON.stringify(result),
    });
  }
  return response;
};

export const NewsletterSubscriptionApi = {
  subscribe,
  unsubscribe,
};
